import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const CloseIcon: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 25 25"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2392 3.74389L4.23919 21.7439L3.03711 20.5418L21.0371 2.54181L22.2392 3.74389Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.23919 2.54181L22.2392 20.5418L21.0371 21.7439L3.03711 3.74389L4.23919 2.54181Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default CloseIcon;
